export const approvalsStoreKey = 'approvals';
